import { render, staticRenderFns } from "./DraggableList.vue?vue&type=template&id=521be922&scoped=true"
import script from "./DraggableList.vue?vue&type=script&lang=js"
export * from "./DraggableList.vue?vue&type=script&lang=js"
import style0 from "./DraggableList.vue?vue&type=style&index=0&id=521be922&prod&scoped=true&lang=css"
import style1 from "./DraggableList.vue?vue&type=style&index=1&id=521be922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521be922",
  null
  
)

export default component.exports